module.exports = __webpack_public_path__ + "img/export_color.484c4a28.svg";